import { produce } from 'solid-js/store';

export default (props, callback) => {
    props.update([...props.path, produce(callback)]);
};